/**
 * Resolve which linked DB should be treated as "active" for a Database Blueprint.
 *
 * The persisted `activeLinkLabel` (in `jamsql-blueprint.json` and mirrored to
 * `MountedFolderBlueprintMetadata`) records the user's last choice from the
 * toolbar's link chip. Two cases need a fallback:
 *
 *  - Legacy blueprints created before Phase 3 don't carry `activeLinkLabel`.
 *  - A label can disappear from `linkedDbs` (link removed, file edited by
 *    hand, git merge). The stored label then dangles and the UI would point
 *    at a non-existent link.
 *
 * Both fall back to the first entry in `linkedDbs`, matching the pre-Phase-3
 * convention. Returns `undefined` only when no links exist at all.
 */
export function resolveActiveLinkLabel(metadata: {
  activeLinkLabel?: string;
  linkedDbs: ReadonlyArray<{ label: string }>;
}): string | undefined {
  if (
    metadata.activeLinkLabel &&
    metadata.linkedDbs.some((l) => l.label === metadata.activeLinkLabel)
  ) {
    return metadata.activeLinkLabel;
  }
  return metadata.linkedDbs[0]?.label;
}
